var map = {
	"./mothership.sg.png": 54389,
	"./mustsharenews.com.png": 41236,
	"./onlinecitizenasia.com.png": 37724,
	"react/utils/LogoUtils/assets/mothership.sg.png": 54389,
	"react/utils/LogoUtils/assets/mustsharenews.com.png": 41236,
	"react/utils/LogoUtils/assets/onlinecitizenasia.com.png": 37724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86724;